/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Modal } from '@mairistem/composants';

import { useActes } from '@/hooks';
import { baseUrlApp } from '@/routes';
import type { Acte, TypeActe } from '@/types';
import { ActeBlock } from './Mention';

interface SaisieMentionModalProps {
  open: boolean;
  title?: string;
  onClose: () => void;
}

const SaisieMentionModal = (props: SaisieMentionModalProps) => {
  const { open, title, onClose } = props;

  const history = useHistory();

  const [typeActe, setTypeActe] = useState<TypeActe>('naissance');
  const [selectedActe, setSelectedActe] = useState<Acte | null>(null);

  const actes = useActes(typeActe);

  const handleTypeActeChange = (nextTypeActe: TypeActe) => {
    setTypeActe(nextTypeActe);
    setSelectedActe(null);
  };

  // Le clic sur une ligne mène directement à la fiche de l'acte, avec la
  // modale « Ajouter une mention » ouverte via `mention` (même pattern
  // que `openSaisieEvenement` sur BlocCreation.tsx).
  const handleActeSelected = (acte: Acte) => {
    setSelectedActe(acte);
    onClose();
    history.push(`${baseUrlApp}${typeActe}/${acte.identifiant}?mention=1`);
  };

  return (
    <Modal open={open} onClose={onClose} size="large" closeIcon>
      <Modal.Header content={title} />
      <Modal.Content>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: 0,
            height: '70vh',
          }}
        >
          <ActeBlock
            typeActe={typeActe}
            actes={actes}
            selectedActe={selectedActe}
            onTypeActeChange={handleTypeActeChange}
            onActeSelected={handleActeSelected}
            onNewSearch={() => setSelectedActe(null)}
          />
        </div>
      </Modal.Content>
    </Modal>
  );
};

export default SaisieMentionModal;
